import React, { useCallback, useEffect } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ProjectTitle from "../components/ProjectTitle";
import DetailFacility from '../components/DetailFacility';
import DetailBill from '../components/DetailBill';
import BidCondition from '../pages/BidCondition';
import BidUpload from '../pages/BidUpload';
import { api_url } from '../api/config/config';


interface Facility {
    id: number,
    contract_number: number,
    name: string,
    contract_start_date: string,
    pref: string,
    address: string,
    contract_type: string,
    category: number,
    usage_total: number,
    contract_usage: number,
    annual_load_factor_p: number,
    annual_load_factor_h: number,
    option_1: string,
    option_2: string,
    option_3: string,
    option_4: string,
    min_bid_amount: number,
    note: string,
    data_file_name: string,
    data_file_path: string,
    supplier_id: number,
    supplier: {
        name: string,
    }
    reseller: {
        name: string,
    },
    [key: string]: any;
}


interface OpportunityStructure {
    id: number,
    due: string,
    close_data: Date,
    company_id: number,
    name: string,
    industry: string,
    bids: {
        bid_id: number,
        status: number,
        upload_file_path: string,
        upload_file_name: string
    }[];
}
const BidConfirm: React.FC = () => {
    // const backendURL = 'http://localhost:8000';
    const backendURL = api_url;

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const { userInfo, userToken, error } = useSelector((state: RootState) => state.auth);
    const [recs, setRecs] = useState<{ [key: string]: Facility[] }>({});
    const opportunityId: number = parseInt(queryParams.get('id') || '0', 10); // idを数値として取得
    const [countFacilities, setCountFacilities] = useState(0);
    const [bidMode, setBidMode] = useState<string>('all');
    const [opportunity, setOpportunity] = useState<OpportunityStructure>();
    const [alreadyBid, setAlreadyBid] = useState(false);
    const [isConfirm, setIsConfirm] = useState(true);

    const fetchOpportunity = useCallback(async () => {
        try {
            const response = await fetch(`${backendURL}/api/enebid/getOpportunity?id=${opportunityId}`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            })

            const res = await response.json();
            if (res.data !== undefined) {
                setOpportunity(res.data);
            }
        } catch (error) {
            console.error('Error: ', error)
        }
    }, [opportunityId, userInfo?.id, userToken])


    const fetchHasAlreadyBid = useCallback(async () => {
        try {
            const response = await fetch(`${backendURL}/api/enebid/hasAlreadyBid`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            });

            const res = await response.json();

            setAlreadyBid(res.data);
        } catch (error) {
            console.error('Error:', error);
        }
    }, [opportunityId, userInfo?.id, userToken])


    const fetchFacilityByOpportunityId = useCallback(async () => {
        try {

            const response = await fetch(`${backendURL}/api/enebid/getFacilityByOpportunityId`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            })

            const res: any = await response.json();
            // return;

            const newRecs: { [key: string]: Facility[] } = {};
            let count = 0;

            res.data.forEach((rec: Facility) => {
                const supplierName = rec.supplier.name;
                if (!newRecs[supplierName]) {
                    newRecs[supplierName] = [];
                }

                newRecs[supplierName].push(rec);
                count++;


            });

            setRecs(newRecs);
            setCountFacilities(count);

        } catch (error) {
            console.error('Error: ', error)
        }
    }, [opportunityId, userToken])

    const handleBid = () => {

    }

    const handleGoBack = () => {
        // 応札条件入力に戻る処理
    };

    useEffect(() => {
        fetchOpportunity();
        fetchFacilityByOpportunityId();
        fetchHasAlreadyBid();

        const bid_mode = queryParams.get('mod_mode') || 'all';
        setBidMode(bid_mode);


    }, [fetchFacilityByOpportunityId, fetchHasAlreadyBid, fetchOpportunity])


    return (
        <>

            <section className="section-name project-details-section">
                <div className="container">
                    {/* <ProjectTitle /> */}
                    <form id="bid-form" method="post">
                        {/* <input type="hidden" name="bid_mode" value={currentBidMode} />
                            <input type="hidden" name="opportunity_id" value={opportunityId} />
                            <input type="hidden" name="status" value={status} /> */}

                        {Object.entries(recs).map(([supplierName, facilities]) => (
                            <div className="bg-ass-demo p-4 mb-5" key={supplierName}>
                                <div className="row">
                                    <div className="col-lg-5 col-md-7 col-10 mx-auto py-3 mb-3">
                                        <div className="bg-white text-center rounded-pill text-sm py-1 fw-300">
                                            <img className="img img-fluid height-25 mb-1 mr-2" src="assets/images/other/icon-poles.svg" alt="" />
                                            {supplierName}管轄
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    {bidMode === 'each' ? (
                                        opportunity && facilities.map((facility) => (
                                            <div className="my-1 pt-1 bg-white" key={facility.id}>
                                                {/* <DetailFacility facility={facility} company={opportunity} /> */}
                                                <div className="bg-white pb-3">
                                                    {/* <DetailBill facility={facility} /> */}
                                                    {/* <BidCondition isConfirm={isConfirm} /> */}
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="my-1 pt-1 bg-white">
                                            {
                                                opportunity && facilities.map((facility) => (
                                                    <div key={facility.id}>
                                                        {/* <DetailFacility facility={facility} company={opportunity} /> */}
                                                        <div className="bg-white pb-3">
                                                            {/* <DetailBill facility={facility} /> */}
                                                        </div>
                                                    </div>
                                                ))}
                                            {/* <BidCondition isConfirm={isConfirm} /> */}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </form>

                    {/* {
                        opportunity !== undefined ? <BidUpload /> : null
                    } */}


                    <div className="text-center mb-lg-4 mb-4">
                        <button id="bidConfirm" type="button" className="btn btn-lg btn-theme btn-danger rounded-pill px-lg-5 px-3 mr-2" onClick={handleBid}>
                            <span className="mx-3">この内容で応札する</span>
                        </button>
                        {countFacilities > 1 && (
                            <button id="goBack" type="button" className="btn btn-lg btn-theme btn-secondary rounded-pill px-lg-5 px-3" onClick={handleGoBack}>
                                <span className="mx-3">応札条件入力に戻る</span>
                            </button>
                        )}
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
}

export default BidConfirm;